var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ActivityAuditApplicationSettingsModel, ActivityAuditClient } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Component, Vue } from "vue-facing-decorator";
const activityAuditClient = new ActivityAuditClient(window.apiUrl);
/// The application-wide retention defaults. Administrator-only - the server enforces that; this
/// page only has to avoid offering it to anyone else.
let AuditLogSettingsVue = class AuditLogSettingsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.model = new ActivityAuditApplicationSettingsModel();
        /// What was loaded, so a reduction can be recognised before it is saved.
        this.originalCompanyDays = 0;
        this.originalApplicationDays = 0;
    }
    get isReduction() {
        return this.model.defaultCompanyDaysToRetain < this.originalCompanyDays
            || this.model.applicationDaysToRetain < this.originalApplicationDays;
    }
    get isValid() {
        const min = this.model.minimumDaysToRetain;
        const max = this.model.maximumDaysToRetain;
        return this.inRange(this.model.defaultCompanyDaysToRetain, min, max)
            && this.inRange(this.model.applicationDaysToRetain, min, max);
    }
    inRange(value, min, max) {
        return Number.isInteger(value) && value >= min && value <= max;
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.load();
        });
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.working = true;
            try {
                this.model = yield activityAuditClient.getApplicationSettings();
                this.originalCompanyDays = this.model.defaultCompanyDaysToRetain;
                this.originalApplicationDays = this.model.applicationDaysToRetain;
            }
            catch (error) {
                Notifier.onError((_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "The Audit Log settings could not be loaded.");
            }
            finally {
                this.working = false;
            }
        });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.working || !this.isValid)
                return;
            // A reduction is irreversible once the purge runs, so it is confirmed explicitly rather
            // than saved on a single click.
            if (this.isReduction) {
                const confirmed = window.confirm("This shortens how long Audit Log entries are kept. Entries older than the new "
                    + "period will be deleted the next time the retention job runs, and cannot be "
                    + "recovered.\n\nSave anyway?");
                if (!confirmed)
                    return;
            }
            this.working = true;
            try {
                yield activityAuditClient.upsertApplicationSettings(this.model);
                this.originalCompanyDays = this.model.defaultCompanyDaysToRetain;
                this.originalApplicationDays = this.model.applicationDaysToRetain;
                Notifier.onSuccess("Audit Log settings saved.");
            }
            catch (error) {
                Notifier.onError((_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "The Audit Log settings could not be saved.");
            }
            finally {
                this.working = false;
            }
        });
    }
};
AuditLogSettingsVue = __decorate([
    Component({
        name: "AuditLogSettingsVue"
    })
], AuditLogSettingsVue);
export default AuditLogSettingsVue;
